import { Paper, styled } from '@mui/material';

export const StyledLessonTimePlaceholderNumberBlock = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
});

export const StyledLessonTimePlaceholderNumberBlockWrap = styled(Paper)({
	padding: '8px 16px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: '10px',
});
